import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

export default function TargetCashAllocationTooltipContent() {
  return (
    <PDSFlexBox flexDirection="column" gap={SIZE.s12} margin={SIZE.s8}>
      <PDSText color={COLOR.white} weight="semibold">
        Target Cash Allocation
      </PDSText>
      <PDSText color={COLOR.white}>
        Pave Pro allows you to configure the amount of cash you would like to
        hold in a portfolio. The percentage of a portfolio allocated to cash may
        fluctuate, but any updates will aim to bring the cash allocation back in
        line with the target.
      </PDSText>
      <PDSText color={COLOR.white}>
        This field is not required. You can enter any value between 3.00% and
        100.00%. If you leave it empty, it will default to 4.00%.
      </PDSText>
    </PDSFlexBox>
  )
}
